import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: inline-block;\n    flex-grow: 1;\n    flex-wrap: wrap;\n    margin: 0;\n\n    ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { Typography } from '../../Typography';
import { getPropsBlocker } from '../../../utils';
var propertyList = {
  isFixed: true
};

var bodyStyle = function bodyStyle(_ref) {
  var isFixed = _ref.isFixed;
  return css(_templateObject(), isFixed ? 'overflow-y: auto;' : '');
};

export var SideSheetBody = styled(Typography).withConfig(getPropsBlocker(propertyList, false))(_templateObject2(), bodyStyle);